import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box } from "@mui/material";

type Props = {
  onClose: () => void;
  onConfirm: () => void;
};

export default function PaidSubscriptionWarningDialog({ onClose, onConfirm }: Props) {
  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>
        <Box sx={styles.titleWrapper}>
          <WarningAmberIcon color="warning" sx={styles.warningIcon} />
          Warning: Paid Subscription
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={styles.content}>
        <Typography variant="subtitle2">
          You are about to remove a <strong>PAID</strong> subscription.
        </Typography>
        <Typography variant="subtitle2">
          This user has an active paid subscription. Removing it will immediately revoke their access to paid features.
        </Typography>
        <Typography variant="subtitle2" color="error">
          This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color="error">
          I Agree, Remove Subscription
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const styles = {
  titleWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "8px"
  },
  warningIcon: {
    fontSize: "28px"
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "10px"
  }
};
